import { RequestMasterTypeEnum } from "@/Schemas/PublicRequest/RequestMasterTypeEnum";
import { ComponentType } from "react";
import { ZodType } from "zod";

import { ContractWithdrawalForm } from "@/Components/PublicRequest/Search/ContractWithdrawalForm";
import { ContractWithdrawalInputSchema } from "@/Schemas/PublicRequest/Search/ContractWithdrawalInput";

export type RequestMasterTypeMessage = {
    headline: string;
    description: string;
};

export type RequestMasterTypeConfigEntry = {
    title: string;
    formComponent: ComponentType;
    formSchema: ZodType;
    formDefaultValues: Record<string, unknown>;
    actionTitle: string;
    invalidContractOnTokenView: RequestMasterTypeMessage;
    invalidContractOnSearchView: RequestMasterTypeMessage;
    invalidContractOnDetailView: RequestMasterTypeMessage;
    reviewTitle: string;
    reviewWarning: RequestMasterTypeMessage;
    modalConfirm: RequestMasterTypeMessage
};

export const requestMasterTypeConfig: Record<
    RequestMasterTypeEnum,
    RequestMasterTypeConfigEntry
> = {
    [RequestMasterTypeEnum.CONTRACT_WITHDRAWAL]: {
        title: "Odstúpenie od zmluvy",
        formComponent: ContractWithdrawalForm,
        formSchema: ContractWithdrawalInputSchema,
        formDefaultValues: {
            contractOrProposalId: "",
            email: "",
            birthDate: "",
        },
        actionTitle: "Odstúpiť od zmluvy",
        invalidContractOnTokenView: {
            headline: "Zmluva sa nenašla alebo nie je možné od nej odstúpiť",
            description:
                "Skúste to prosím neskôr alebo vyhľadajte zmluvu pomocou vašich údajov.",
        },
        invalidContractOnSearchView: {
            headline: "Zmluva sa nenašla alebo nie je možné od nej odstúpiť",
            description:
                "Nepodarilo sa nájsť zmluvu pre zadané údaje alebo od zmluvy nie je možné odstúpiť. Skontrolujte prosím správnosť údajov a skúste to znova.",
        },
        invalidContractOnDetailView: {
            headline: "Zmluva sa nenašla alebo nie je možné od nej odstúpiť",
            description:
                "Nepodarilo sa nájsť zmluvu alebo od zmluvy nie je možné odstúpiť. Skontrolujte prosím správnosť údajov a skúste to znova.",
        },
        reviewTitle: "Kontrola údajov a odstúpenie od zmluvy",
        reviewWarning: {
            headline: "Skontrolujte údaje pred odstúpením od zmluvy",
            description:
                "Uistite sa, že všetky údaje sú správne a že naozaj chcete odstúpiť od zmluvy. Po potvrdení bude <b>táto akcia nezvratná a nebude ju možné vrátiť späť</b>.",
        },
        modalConfirm: {
            headline: "Naozaj chcete odstúpiť od zmluvy?",
            description:
                "Táto akcia je nezvratná a po jej potvrdení nebude možné zmluvu obnoviť ani vrátiť späť.",
        }
    },
};

export const isRequestMasterTypeEnum = (value: number): value is RequestMasterTypeEnum =>
    Number.isInteger(value) && value in requestMasterTypeConfig;
